const doc = [({"da":({"js":({"admin":({"economy":({"subscription_renewal_generations":({"subscription_renewals":"Medlemskabsfornyelser"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;